import { useState } from "react";
import { BBOT_DJANGO_SERVER } from "Config";
import { BbotTabs, Button, OPContainer, PageLoadingSpinner } from "top-component-library";
import { AVAILABLE_HOURS_ROUTE } from "./constants";
import { LegacyLinkAlert } from "./styles";
import { useSchedules } from "./useSchedules";
import { useMenus } from "./useMenus";
import PrepStationAvailabilityTab from "./tabs/PrepStationAvailabilityTab";
import MenuSettingsTab from "./tabs/MenuSettingsTab";
import CheckMenuStatusModal from "./CheckMenuStatusModal";

const AvailableHours = ({ selectedCustomer, userInfo }) => {
  const { stations, forceAllowOrderAhead, techSupportContact, isLoading, saveStationSchedule } =
    useSchedules(selectedCustomer);
  const menusApi = useMenus(selectedCustomer);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const legacyLink =
    BBOT_DJANGO_SERVER +
    (userInfo?.role === "admin" ? "/superuser/console/#!/edit/schedule" : "/owner/console/#!/edit/schedule");

  return (
    <OPContainer
      title="Available Hours + Menu Settings"
      url={AVAILABLE_HOURS_ROUTE}
      selectedCustomer={selectedCustomer}
      userInfo={userInfo}
    >
      <div className="margin-bottom-4">
        <LegacyLinkAlert
          message={
            <span>
              We&apos;ve updated this page! We&apos;ll retire the old page soon but you can view it{" "}
              <a href={legacyLink}>here.</a>
            </span>
          }
        />
      </div>
      <div className="margin-bottom-3">
        <Button type="primary" onClick={() => setStatusModalOpen(true)}>
          View Current Menu Statuses
        </Button>
      </div>
      {isLoading ? (
        <PageLoadingSpinner />
      ) : (
        <BbotTabs id="available-hours">
          <BbotTabs.TabPane tab="Prep Station Availability" key="prep-stations">
            <div className="padding-x-2">
              <PrepStationAvailabilityTab
                stations={stations}
                forceAllowOrderAhead={forceAllowOrderAhead}
                techSupportContact={techSupportContact}
                onSaveStation={saveStationSchedule}
              />
            </div>
          </BbotTabs.TabPane>
          <BbotTabs.TabPane tab="Menu Settings" key="menu-settings">
            <div className="padding-x-2">
              <MenuSettingsTab
                menus={menusApi.menus}
                isLoading={menusApi.isLoading}
                forceAllowOrderAhead={forceAllowOrderAhead}
                techSupportContact={techSupportContact}
                onSaveMenu={menusApi.saveMenu}
              />
            </div>
          </BbotTabs.TabPane>
        </BbotTabs>
      )}
      <CheckMenuStatusModal visible={statusModalOpen} onClose={() => setStatusModalOpen(false)} />
    </OPContainer>
  );
};

export default AvailableHours;
